export const buildNumber = '20260602.4';
export const version = 'main';
export const latestCommit = '6de652c18d502427b10f43a5a4574bb8d4b0f973';
